// Opens and scrolls to an accordion row whose id matches the URL hash,
// e.g. linking to /collections/vintage-technology-bih#video-game-controllers
// opens the "video game controllers" accordion row and scrolls it into view.
async function openAccordionFromHash() {
  const hash = decodeURIComponent(location.hash.slice(1));
  if (!hash) return;

  const target = document.getElementById(hash);
  if (!target) return;

  const details = target.matches('details') ? target : target.closest('details');
  if (!details) return;

  // Ensure accordion-custom has already upgraded (and set its default open
  // state) before we force this row open, otherwise it can get closed again.
  await customElements.whenDefined('accordion-custom').catch(() => {});

  details.open = true;

  const headerHeight = getComputedStyle(document.body).getPropertyValue('--header-height') || '0px';
  details.style.scrollMarginTop = headerHeight;
  details.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

document.addEventListener('DOMContentLoaded', openAccordionFromHash);
window.addEventListener('hashchange', openAccordionFromHash);
